<div class="faq-container">
    <div class="container">
        <h3 class="heading text-center mb-4 mb-md-4">{{ 'faqs.title' | translate }}</h3>
        <div class="search-container">
            <input type="text" class="form-control faq-search-input" (keyup)="filterFaqList($event)" [placeholder]="('faqs.search_placeholder' | translate )">
        </div>
        <div class="faq-wrapper">
            <div class="faq" *ngFor="let faq of faqList; let i = index;">
                <div class="question" (click)="toggleAccordion(i, 'default')">
                    <div class="text">{{ faq.question }}</div>
                    <div class="icon">
                        <mat-icon *ngIf="activeIndex !== i">add_2</mat-icon>
                        <mat-icon *ngIf="activeIndex === i">remove</mat-icon>
                    </div>
                </div>
                <div class="answer secondary-color" *ngIf="activeIndex === i" [innerHTML]="faq.answer"></div>
            </div>
            <h4 *ngIf="marketPlacefaqList.length"><br>{{ 'faqs.marketplace_faqs' | translate }}<br></h4>
            <div class="faq" *ngFor="let faq of marketPlacefaqList; let i = index;">
                <div class="question" (click)="toggleAccordion(i, 'marketPlace')">
                    <div class="text">{{ faq.question }}</div>
                    <div class="icon" >
                        <mat-icon *ngIf="marketPlaceActiveIndex !== i">add_2</mat-icon>
                        <mat-icon *ngIf="marketPlaceActiveIndex === i">remove</mat-icon>
                    </div>
                </div>
                <div class="answer secondary-color" *ngIf="marketPlaceActiveIndex === i" [innerHTML]="faq.answer"></div>
            </div>
            <h4 *ngIf="friendsfaqList.length"><br>{{ 'faqs.friend_faqs' | translate }}<br></h4>
            <div class="faq" *ngFor="let faq of friendsfaqList; let i = index;">
                <div class="question" (click)="toggleAccordion(i, 'friends')">
                    <div class="text">{{ faq.question }}</div>
                    <div class="icon">
                        <mat-icon *ngIf="friendsActiveIndex !== i">add_2</mat-icon>
                        <mat-icon *ngIf="friendsActiveIndex === i">remove</mat-icon>
                    </div>
                </div>
                <div class="answer secondary-color" *ngIf="friendsActiveIndex === i" [innerHTML]="faq.answer"></div>
            </div>
            <h4 *ngIf="communitiesfaqList.length"><br>{{ 'faqs.communities_faqs' | translate }}<br></h4>
            <div class="faq" *ngFor="let faq of communitiesfaqList; let i = index;">
                <div class="question" (click)="toggleAccordion(i, 'communities')">
                    <div class="text">{{ faq.question }}</div>
                    <div class="icon">
                        <mat-icon *ngIf="communitiesActiveIndex !== i">add_2</mat-icon>
                        <mat-icon *ngIf="communitiesActiveIndex === i">remove</mat-icon>
                    </div>
                </div>
                <div class="answer secondary-color" *ngIf="communitiesActiveIndex === i" [innerHTML]="faq.answer"></div>
            </div>
            <h4 *ngIf="vinoCoinsfaqList.length"><br>{{ 'faqs.vinocoin_faqs' | translate }}<br></h4>
            <div class="faq" *ngFor="let faq of vinoCoinsfaqList; let i = index;">
                <div class="question" (click)="toggleAccordion(i, 'vinoCoins')">
                    <div class="text">{{ faq.question }}</div>
                    <div class="icon" >
                        <mat-icon *ngIf="vinoCoinsActiveIndex !== i">add_2</mat-icon>
                        <mat-icon *ngIf="vinoCoinsActiveIndex === i">remove</mat-icon>
                    </div>
                </div>
                <div class="answer secondary-color" *ngIf="vinoCoinsActiveIndex === i" [innerHTML]="faq.answer"></div>
            </div>     
            <h4 class="no-match text-center" *ngIf="!faqList.length && !marketPlacefaqList.length && !friendsfaqList.length && !communitiesfaqList.length && !vinoCoinsfaqList.length">{{ 'No Match Found' }}</h4>
        </div>
    </div>
</div>